(function () {
  var DEFAULT_SPEED = 100;
  var resizeTimer;

  function resetMarquee(wrap, track) {
    wrap.classList.remove('has-marquee');
    track.classList.remove('is-marquee');
    track.style.removeProperty('animation-duration');
    track.style.removeProperty('--eisc-track-width');
    track.querySelectorAll('[data-marquee-clone]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function initMarquee(wrap) {
    var track = wrap.querySelector('.eisc-items-track');
    if (!track) return;

    resetMarquee(wrap, track);

    var contentWidth = track.scrollWidth;
    if (contentWidth <= track.clientWidth) return;

    var speed = parseFloat(wrap.dataset.speed) || DEFAULT_SPEED;

    var originals = Array.from(track.children);

    var joinDivider = document.createElement('div');
    joinDivider.className = 'eisc-divider';
    joinDivider.setAttribute('data-marquee-clone', '');
    joinDivider.setAttribute('aria-hidden', 'true');
    track.appendChild(joinDivider);

    var slideWidth = track.scrollWidth;

    originals.forEach(function (child) {
      var clone = child.cloneNode(true);
      clone.setAttribute('data-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    track.style.setProperty('--eisc-track-width', '-' + slideWidth + 'px');
    track.style.animationDuration = (slideWidth / speed) + 's';
    wrap.classList.add('has-marquee');
    track.classList.add('is-marquee');
  }

  function initAll() {
    document.querySelectorAll('.eisc-items').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 200);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var wrap = e.target.querySelector('.eisc-items');
    if (wrap) initMarquee(wrap);
  });
})();
